import { WorkspaceId } from "../../core";
import { RoleV1 } from "../types.generated";
import { unsafeRoleV1 } from "./internal";
import { roleArgsV1, roleArityV1, roleNameV1 } from "./parse";

export function roleWithWorkspaceIdV1(
  role: RoleV1,
  workspaceId: WorkspaceId
): RoleV1 {
  const name = roleNameV1(role);
  const arity = roleArityV1(role);

  if (arity === 0) {
    return unsafeRoleV1(name);
  } else {
    return unsafeRoleV1(
      [name, workspaceId, ...roleArgsV1(role).slice(1)].join(":")
    );
  }
}
